import ImportHelper from './import.helper'

const RR310 = () => { return ImportHelper.importAll(require.context("../assets/gallery/RTR310/", true, /\.webp/)); }
const SPORTELS = () => { return ImportHelper.importAll(require.context("../assets/gallery/SPORT100ELS/", true, /\.webp/)); }
const SPORTKLS = () => { return ImportHelper.importAll(require.context("../assets/gallery/SPORT100KLS/", true, /\.webp/)); }
const STRYKER = () => { return ImportHelper.importAll(require.context("../assets/gallery/STRYKER125/", true, /\.webp/)); }
const MAX125 = () => { return ImportHelper.importAll(require.context("../assets/gallery/MAX125/", true, /\.webp/)); }
const APACHE1602V = () => { return ImportHelper.importAll(require.context("../assets/gallery/RTR1602V/", true, /\.webp/)); }
const APACHE1604V = () => { return ImportHelper.importAll(require.context("../assets/gallery/RTR1604V/", true, /\.webp/)); }
const APACHE1802V = () => { return ImportHelper.importAll(require.context("../assets/gallery/RTR1802V/", true, /\.webp/)); }
const APACHE2002V = () => { return ImportHelper.importAll(require.context("../assets/gallery/RTR2004V/", true, /\.webp/)); }
const APACHE200FI = () => { return ImportHelper.importAll(require.context("../assets/gallery/RTR2004V/", true, /\.webp/)); }
const RAIDER125 = () => { return ImportHelper.importAll(require.context("../assets/gallery/RAIDER125/", true, /\.webp/)); }
const NTORQ125 = () => { return ImportHelper.importAll(require.context("../assets/gallery/NTORQ125/", true, /\.webp/)); }
const NTORQ125RACING = () => { return ImportHelper.importAll(require.context("../assets/gallery/NTORQ125RACE/", true, /\.webp/)); }
const NTORQ125FI = () => { return ImportHelper.importAll(require.context("../assets/gallery/NTORQ125FI/", true, /\.webp/)); }
const NEONX = () => { return ImportHelper.importAll(require.context("../assets/gallery/NEONX110/", true, /\.webp/)); }
const BASICO = () => { return ImportHelper.importAll(require.context("../assets/gallery/KINGGS/", true, /\.webp/)); }
const ESPECIAL = () => { return ImportHelper.importAll(require.context("../assets/gallery/KINGGSESPECIAL/", true, /\.webp/)); }
const FULL = () => { return ImportHelper.importAll(require.context("../assets/gallery/KINGGSFULL/", true, /\.webp/)); }

export const GalleryLoader = {
    "Apache RR 310" : RR310,
    "Sport 100 ELS" : SPORTELS,
    "Sport 100 KLS" : SPORTKLS,
    "Stryker" : STRYKER,
    "Max 125" : MAX125,
    "Apache 160 2V" : APACHE1602V,
    "Apache 160 4V" : APACHE1604V,
    "Apache 180 2V" : APACHE1802V,
    "Apache 200 2V" : APACHE2002V,
    "Apache 200 fi" : APACHE200FI,
    "Raider 125" : RAIDER125,
    "Ntorq 125" : NTORQ125,
    "Ntorq 125 Racing" : NTORQ125RACING,
    "Ntorq 125 fi" : NTORQ125FI,
    "Neo NX 110" : NEONX,
    "Motocarro King Basico" : BASICO,
    "Motocarro King Carpa Especial" : ESPECIAL,
    "Motocarro King Carpa Full" : FULL,
} 